import React, { useState, useRef } from "react";
import { Tabs, Tab, Col, Row, Pagination, Button } from "react-bootstrap";
import SurveyBarChart from "./charts/SurveyBarChart";
import QuestionBarChart from "./charts/QuestionBarChart";
import { GetToken } from "../common/getToken";
import { useNavigate, useParams, Link } from "react-router-dom";
import QuestionModal from "./QuestionModal";
import AllQuestionsGrid from "./Grid/AllQuestionsGrid";
import { FaLongArrowAltLeft } from "react-icons/fa";
import GraphQuestionsGrid from "./Grid/GraphQuestionsGrid";
import SurveyAnalyticsTab from "./SurveyAnalyticsTab";
import QuestionAnalyticsTab from "./QuestionAnalyticsTab";
import axios from "axios";
import Swal from "sweetalert2";
import { MdPeopleAlt, MdQuestionAnswer, MdBarChart } from "react-icons/md";
import { useEffect } from "react";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const ChartTabs = ({ overview, surveyDetails, BASE_URL, surveyId }) => {
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;

  /* variable declarations */
  pdfMake.vfs = pdfFonts.vfs;
  let history = useNavigate();
  const childRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [questionId, setQuestionId] = useState();
  const [questionText, setQuestionText] = useState();
  const [popupdata, setpopupdata] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTabSecond, setLoadingTabSecond] = useState(true);
  const [nodata, setNodata] = useState(false);
  const [detailGraph, setDetailGraph] = useState([]);
  const [activeTab, setActiveTab] = useState("surveyAnalytics");
  const [activePage, setActivePage] = useState(() => 1);
  const [PageNumberCount, setPageNumberCount] = useState(() => 1);
  const [limit, setLimit] = useState(() => 1);
  const [answerTypeId, setAnswerTypeId] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [sortBy, setSortBy] = useState();
  const [totalQuestions, setTotalQuestions] = useState();
  const [overviewData, setOverviewData] = useState([]);
  const [filterButton, setFilterButton] = useState("side");

  let items = [];
  let questions = "Total Questions:";
  let response = "Total Responses:";
  let surveyees = "Total Respondents:";

  for (let number = 1; number <= Math.ceil(totalQuestions / 5); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePage}
        onClick={() => setLimit(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  useEffect(() => {
    // getSurveyAnalytics(surveyId);
  }, [
    allQuestions,
    history,
    surveyId,
    limit,
    answerTypeId,
    startDate,
    endDate,
    sortBy,
  ]);

  useEffect(() => {
    if (activePage === 1) {
      setPageNumberCount(activePage);
    } else {
      let a = 0;
      for (let i = 1; i < activePage; i++) {
        a = a + 5;
      }
      setPageNumberCount(a + 1);
    }
  }, [activePage]);

  const changeFilterBox = async () => {
    if (filterButton == "hide") {
      setFilterButton("show");
    } else {
      setFilterButton("hide");
    }
  };

  return (
    <>
      {/* ── STAT CARDS ── */}
      <Row className="g-4 mb-4 mt-3 row-cols-1 row-cols-md-3">
        <Col>
          <div className="stat-card stat-card--respondents">
            <div className="stat-card-icon">
              <MdPeopleAlt />
            </div>
            <div className="stat-card-body">
              <span className="stat-card-label">Total Respondents</span>
              <span className="stat-card-value">{surveyDetails.uniqueUsers ?? 0}</span>
            </div>
            <div className="stat-card-glow" />
          </div>
        </Col>
        <Col>
          <div className="stat-card stat-card--questions">
            <div className="stat-card-icon">
              <MdQuestionAnswer />
            </div>
            <div className="stat-card-body">
              <span className="stat-card-label">Total Questions</span>
              <span className="stat-card-value">{surveyDetails.totalQuestions ?? 0}</span>
            </div>
            <div className="stat-card-glow" />
          </div>
        </Col>
        <Col>
          <div className="stat-card stat-card--responses">
            <div className="stat-card-icon">
              <MdBarChart />
            </div>
            <div className="stat-card-body">
              <span className="stat-card-label">Total Responses</span>
              <span className="stat-card-value">{surveyDetails.totalquestionResponses ?? 0}</span>
            </div>
            <div className="stat-card-glow" />
          </div>
        </Col>
      </Row>
      <center
        style={{ paddingTop: "25vh" }}
        className={loading ? "" : "d-none"}
      >
        <br />
        <h4>Loading...</h4>
      </center>

      <span className={!loading ? "" : "d-none"}>
        {surveyDetails.uniqueUsers > 0 ? (
          <Row>
            <Col lg={12}>
              <div className="analytics-tabs-wrap">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={activeTab}
                  onSelect={(t) => setActiveTab(t)}
                  className="analytics-tabs border-0"
                >
                  <Tab eventKey="surveyAnalytics" title="Overview">
                    <SurveyAnalyticsTab
                      surveyId={surveyId}
                      surveyDetails={surveyDetails}
                    />
                  </Tab>
                  <Tab eventKey="questionAnalytics" title="Question Analytics">
                    <QuestionAnalyticsTab
                      surveyId={surveyId}
                      surveyDetails={surveyDetails}
                    />
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col lg={12} className="text-center">
              <div className="py-5">
                <h5 className="text-danger">
                  No Respondents found for this survey
                </h5>
              </div>
            </Col>
          </Row>
        )}
      </span>

      <QuestionModal
        show={modalShow}
        questionNo={questionId}
        QuestionText={questionText}
        popupdata={popupdata}
        surveyDetails={surveyDetails}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default ChartTabs;
